import { render, staticRenderFns } from "./TestSelector.vue?vue&type=template&id=2fc72596"
import script from "./TestSelector.vue?vue&type=script&lang=js"
export * from "./TestSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports